import React from 'react'
import Main from '../components/HabPage/Main'

const HabPage = () => {
  return (
    <div>
        <Main/>
    </div>
  )
}

export default HabPage